import { Injectable } from '@angular/core';
import { BaseService } from '../abstracts/base.service';
import { AlanModel } from '../models/alan.model';
import { ResultModel } from "../models/result.model";
@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService extends BaseService {

  createResetToken(email: string) {
    var form = new FormData;
    form.append('Email', email);
    return this.httpClient.post<ResultModel>(this.getApiUrl('auth/reset-password'), form);
  }

  resetPassword(token: string, password: string) {
    return this.httpClient.put<ResultModel>(this.getApiUrl('auth/reset-password'), { Token: token, Password: password });
  }

  getTokenInfo(token: string) {
    return this.httpClient.get<ResultModel>(this.getApiUrl('auth/reset-password?pToken=' + token));
  }


}












